import { logWrapper } from '../utils';

export default {
  executionModel: [
    'runtimeConstant',
    '$filter',
    'revService',
    'ETaskTypes',
    function (runtimeConstant, $filter, Revision, ETaskTypes) {
      function Execution(data) {
        this.execution = data.Execution;

        this.currentStep = {
          startDate: data.CurrentStepStartDate,
          elementName: data.CurrentStepElementName,
          elementType: data.CurrentStepElementType || 0,
          users: data.CurrentStepUsers,
          groups: data.CurrentStepGroups,
        };

        this.revision = new Revision({
          Code: data.RevisionCode,
          Title: data.RevisionTitle,
          Extension: data.RevisionExtension,
          Author: data.RevisionAuthor,
          Date: data.RevisionDate,
          IsSigned: data.RevisionIsSigned,
        });

        this.workflow = {
          createdBy: data.WorkflowCreatedUser,
          createdDate: data.WorkflowCreatedDate,
          workflowRevision: data.WorkflowRevision,
          name: data.WorkflowName,
          description: data.WorkflowDescription,
        };
      }

      function filter() {
        return (
          this.workflow.name +
          ' ' +
          this.revision.title +
          ' ' +
          this.workflow.name +
          ' ' +
          this.currentStep.elementName
        );
      }

      function currentStepType() {
        var type = '';
        switch (this.currentStep.elementType) {
          case ETaskTypes.Review:
            type = 'REVIEW';
            break;
          case ETaskTypes.Notification:
            type = 'NOTIFICATION';
            break;
          case ETaskTypes.Decision:
            type = 'DECISION';
            break;
          case ETaskTypes.Approve:
            type = 'APPROVE';
            break;
          case ETaskTypes.ApproveWithSignature:
            type = 'APPROVE';
            break;
          case ETaskTypes.Training:
            type = 'TRAINING';
            break;
          case ETaskTypes.Distribution:
            type = 'DISTRIBUTION';
            break;
          case ETaskTypes.Analysis:
            type = 'ANALYSIS';
            break;
          case ETaskTypes.Start:
            type = 'START';
            break;
          case ETaskTypes.End:
            type = 'END';
            break;
        }

        return type;
      }

      function stepPersons() {
        var persons = [];

        for (var i = 0, len = this.currentStep.users.length; i < len; i++) {
          persons.push(this.currentStep.users[i].Name);
        }

        for (
          var j = 0, length = this.currentStep.groups.length;
          j < length;
          j++
        ) {
          persons.push(this.currentStep.groups[j].Name);
        }

        return persons;
      }

      function documentInfo() {
        return String.format($filter('translate')('DOCUMENT SEND BY AT'), [
          this.revision.author.Name,
          $filter('date')(this.revision.date, 'dd/MM/yyyy'),
        ]);
      }

      function run() {
        try {
          Execution.prototype = {
            filter: logWrapper(filter, runtimeConstant.isDebugModelsInternals),
            currentStepType: logWrapper(
              currentStepType,
              runtimeConstant.isDebugModelsInternals
            ),
            stepPersons: logWrapper(
              stepPersons,
              runtimeConstant.isDebugModelsInternals
            ),
            documentInfo: logWrapper(
              documentInfo,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return Execution;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }
      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
